<uitk-header class="optum-header-light">
    <uitk-header-logo class="align-logo-and-icon">
        <img class="uitk-c-header__logo" [src]="logosConfig?.logo.path" [alt]="logosConfig?.logo.alt" />
        <div class="align-border-logo-and-text">|</div>
        <a href="#" class="uitk-c-header__product-name">Data Quality as a Service</a>
    </uitk-header-logo>
    <uitk-navigation-global>
        <uitk-navigation-panel>
            <uitk-navigation-panel-item>
                <span uitkNavRoute>
                    @if (globalNavModel.links && globalNavModel.links[0]) {
                    <span>
                        {{globalNavModel.links[0].textTemplate}}
                    </span>
                    }
                </span>
            </uitk-navigation-panel-item>
            <!-- <uitk-navigation-panel-item>
                <span uitkNavRoute>
                    @if (globalNavModel.links && globalNavModel.links[1]) {
                    <span>
                        {{globalNavModel.links[1].textTemplate}}
                    </span>
                    }
                </span>
                <uitk-navigation-panel>
                    <uitk-navigation-panel-item>
                        <span uitkNavRoute (click)="handleOnNavClick(globalNavModel.links[1].dropDown.links[0])">
                            Data Profiling
                        </span>
                    </uitk-navigation-panel-item>
                </uitk-navigation-panel>
            </uitk-navigation-panel-item> -->
            <uitk-navigation-panel-item>
                <span uitkNavRoute>
                    @if (globalNavModel.links && globalNavModel.links[1]) {
                    <span>
                        {{globalNavModel.links[1].textTemplate}}
                    </span>
                    }
                </span>
            </uitk-navigation-panel-item>
            <!------------------------------Tenant List Array---------------------------------------->
            <uitk-navigation-panel-item>
                <span uitkNavRoute>
                    @if (globalNavModel.links && globalNavModel.links[2]) {
                    <span>
                        {{globalNavModel.links[2].textTemplate}}
                    </span>
                    }
                </span>
                @if(globalNavModel.links && globalNavModel.links[2] && globalNavModel.links[2].dropDown &&
                globalNavModel.links[2].dropDown.links){
                <uitk-navigation-panel>
                    @for(i of globalNavModel.links[2].dropDown.links;track i.id){
                    <uitk-navigation-panel-item>
                        <span uitkNavRoute (click)="handleOnNavClick(i)">
                            {{i.textTemplate}}
                        </span>
                    </uitk-navigation-panel-item>
                    }
                </uitk-navigation-panel>
                }
                @else if(globalNavModel.links && globalNavModel.links[2] && globalNavModel.links[2] &&
                !globalNavModel.links[2].dropDown){
                <uitk-navigation-panel>
                    <span>
                        {{globalNavModel.links[2].textTemplate}}
                    </span>
                </uitk-navigation-panel>
                }
            </uitk-navigation-panel-item>
            <!------------------------------This is for tenant array---------------------------------------->
            <uitk-navigation-panel-item>
                <span uitkNavRoute>
                    @if (globalNavModel.links && globalNavModel.links[3]) {
                    <span>
                        {{globalNavModel.links[3].textTemplate}}
                    </span>
                    }
                </span>
                @if(globalNavModel.links && globalNavModel.links[3] && globalNavModel.links[3].dropDown.links){
                <uitk-navigation-panel>
                    @for(i of globalNavModel.links[3].dropDown.links;track i.id){
                    <uitk-navigation-panel-item>
                        <span uitkNavRoute (click)="handleOnNavClick(i)">
                            {{i.textTemplate}}
                        </span>
                    </uitk-navigation-panel-item>
                    }
                </uitk-navigation-panel>
                }
            </uitk-navigation-panel-item>
            <uitk-navigation-panel-item>
                <span uitkNavRoute>
                    @if (globalNavModel.links && globalNavModel.links[4]) {
                    <span (click)="handleOnNavClick(globalNavModel.links[4])">
                        {{globalNavModel.links[4].textTemplate}}
                    </span>
                    }
                </span>
            </uitk-navigation-panel-item>
        </uitk-navigation-panel>
    </uitk-navigation-global>
</uitk-header>
<div>
    <uitk-navigation-primary-horizontal>
        <uitk-navigation-panel>
            <uitk-navigation-panel-item>
                @if (primaryNavModel.links && primaryNavModel.links[0]) {
                <a uitkNavRoute [routerLink]="primaryNavModel.links[0].url"
                    [class.active]="isActive(primaryNavModel.links[0].url)">
                    {{primaryNavModel.links[0].textTemplate}}
                </a>
                }
            </uitk-navigation-panel-item>
            <uitk-navigation-panel-item>
                @if (primaryNavModel.links && primaryNavModel.links[1]) {
                <a uitkNavRoute [routerLink]="primaryNavModel.links[1].url"
                    [class.active]="isActive(primaryNavModel.links[1].url || isDropdownActive(primaryNavModel.links[1].dropDown.links))">
                    {{primaryNavModel.links[1].textTemplate}}
                </a>
                <uitk-navigation-panel>
                    @for(i of primaryNavModel.links[1].dropDown.links;track i.id){
                    <uitk-navigation-panel-item>
                        <span uitkNavRoute routerLink="i.url"
                            (click)="i.disabled ? $event.preventDefault() : handlePrimaryClick(i)"
                            [routerLink]="i.disabled ? null : i.url">
                            {{i.textTemplate}}
                        </span>
                    </uitk-navigation-panel-item>
                    }
                </uitk-navigation-panel>
                }
            </uitk-navigation-panel-item>
            <uitk-navigation-panel-item>
                @if (primaryNavModel.links && primaryNavModel.links[2]) {
                <a uitkNavRoute [routerLink]="primaryNavModel.links[2].url"
                    [class.active]="isActive(primaryNavModel.links[2].url || isDropdownActive(primaryNavModel.links[2].dropDown.links))">
                    {{primaryNavModel.links[2].textTemplate}}
                </a>
                <uitk-navigation-panel>
                    @for(i of primaryNavModel.links[2].dropDown.links;track i.id){
                    <uitk-navigation-panel-item>
                        <span uitkNavRoute [class.disabled]="i.disabled"
                            (click)="i.disabled ? $event.preventDefault() : handlePrimaryClick(i)"
                            [routerLink]="i.disabled ? null : i.url">
                            {{i.textTemplate}}
                        </span>
                    </uitk-navigation-panel-item>
                    }
                </uitk-navigation-panel>
                }
            </uitk-navigation-panel-item>
            <uitk-navigation-panel-item>
                @if (primaryNavModel.links && primaryNavModel.links[3]) {
                <a uitkNavRoute [routerLink]="primaryNavModel.links[3].url"
                    [class.active]="isActive(primaryNavModel.links[3].url || isDropdownActive(primaryNavModel.links[3].dropDown.links))">
                    {{primaryNavModel.links[3].textTemplate}}
                </a>
                <uitk-navigation-panel>
                    @for(i of primaryNavModel.links[3].dropDown.links;track i.id){
                    <uitk-navigation-panel-item>
                        <span uitkNavRoute [class.disabled]="i.disabled"
                            (click)="i.disabled ? $event.preventDefault() : handlePrimaryClick(i)"
                            [routerLink]="i.disabled ? null : i.url">
                            {{i.textTemplate}}
                        </span>
                    </uitk-navigation-panel-item>
                    }
                </uitk-navigation-panel>
                }
            </uitk-navigation-panel-item>
            <uitk-navigation-panel-item>
                @if (primaryNavModel.links && primaryNavModel.links[4]) {
                <a uitkNavRoute [routerLink]="primaryNavModel.links[4].url"
                    [class.active]="isActive(primaryNavModel.links[4].url || isDropdownActive(primaryNavModel.links[4].dropDown.links))">
                    {{primaryNavModel.links[4].textTemplate}}
                </a>
                <uitk-navigation-panel>
                    @for(i of primaryNavModel.links[4].dropDown.links;track i.id){
                        <uitk-navigation-panel-item>
                            <span uitkNavRoute  [routerLink]="i.url"
                                (click)="handlePrimaryClick(i)">
                                {{i.textTemplate}}
                            </span>
                        </uitk-navigation-panel-item>
                    }
                </uitk-navigation-panel>
                }
            </uitk-navigation-panel-item>
            <!-- <uitk-navigation-panel-item>
                @if (primaryNavModel.links && primaryNavModel.links[5]) {
                <a uitkNavRoute [routerLink]="primaryNavModel.links[5].url">
                    {{primaryNavModel.links[5].textTemplate}}
                </a>
                }
            </uitk-navigation-panel-item>-->
        </uitk-navigation-panel> 
    </uitk-navigation-primary-horizontal>
    <main>
        <router-outlet></router-outlet>
        <div *ngIf="showLoader" class="uitk-u-overlay uitk-u-z-index--7" tabindex="-1">
            <uitk-loading-indicator uitkId="loader" visibleText="Loading, please wait..."
                spinnerSize="large"></uitk-loading-indicator>
        </div>
    </main>
    <uitk-footer></uitk-footer>
    <!-- =====================Start : Contact us dialog box=========================================-->
    <uitk-dialog [(showModal)]="showContactDialog" id='contactus' [width]="'980px'">
        <uitk-dialog-header>
            Contact Us
        </uitk-dialog-header>
        <uitk-dialog-content>
            <div>
                <div class="contactus-tech">For technical support, please submit a
                    <a class="anchor-blue" (click)="openServiceNowLink()">
                        ServiceNow</a> ticket to the following <b>Assignment Workgroup: <i>DQaaS Rules Engine
                            Support</i></b>.
                </div>
                <div class="wrap-dlg-btns">
                    <button
                        class="uitk-c-button uitk-c-button--primary uitk-u-margin-right--base uitk-u-margin-bottom--xs button-wrap"
                        (click)="showContactDialog=false">OK
                    </button>
                </div>
            </div>
        </uitk-dialog-content>
    </uitk-dialog>
    <!-- =====================End : Contact us dialog box=========================================-->
    <uitk-notification class="uitk-u-margin-bottom--lg" [show]="jermessageModal.visible" uitkId="success"
        variant="success" [displayButton]="true" [buttonText]="jermessageModal.buttonText"
        (onButtonClick)="handleButtonClick($event)">
        <span>{{ jermessageModal.content }}</span>
    </uitk-notification>
    <uitk-notification class="uitk-u-margin-bottom--lg" uitkId="errorDemoId" variant="error"
        [show]="infoMessage.isInfoNotificationVisible" [displayButton]="true" [buttonText]="infoMessage.buttonText"
        (onButtonClick)="handleButtonClick($event)">
        <span>{{ infoMessage.content }}</span>
    </uitk-notification>